import Icon from '@/components/ui/AppIcon';

interface TrustIndicator {
  icon: string;
  title: string;
  description: string;
}

const TrustIndicators = () => {
  const indicators: TrustIndicator[] = [
    {
      icon: 'ShieldCheckIcon',
      title: 'Fully Insured',
      description: 'Comprehensive liability and workers\' compensation coverage',
    },
    {
      icon: 'ClockIcon',
      title: '24-Hour Response',
      description: 'We respond to all quote requests within one business day',
    },
    {
      icon: 'CheckBadgeIcon',
      title: 'Satisfaction Guaranteed',
      description: 'We\'re not satisfied until you are completely happy',
    },
    {
      icon: 'UserGroupIcon',
      title: 'Experienced Team',
      description: 'Professional technicians with years of expertise',
    },
  ];

  return (
    <div className="bg-surface border border-border rounded-lg p-8">
      <h3 className="font-serif text-xl font-semibold text-foreground mb-6 text-center">
        Why Choose CrystalClean?
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {indicators.map((indicator, index) => (
          <div key={index} className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="flex items-center justify-center w-10 h-10 bg-accent rounded-lg">
                <Icon name={indicator.icon as any} size={20} className="text-primary" />
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-foreground mb-1">{indicator.title}</h4>
              <p className="text-sm text-muted-foreground">{indicator.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustIndicators;